import React, { useEffect, useCallback, useState } from 'react'
import logo from '../../assets/images/cacti-club-logo.png'
import TextDialog from '../TextDialog/TextDialog'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { truncateFromCenter } from '../../helpers/sharedFunctions'
import { config, isWalletConnected, setWalletConnected } from '../../utils/config'

interface Props {
  onClickCollection: Function
  showCollection: boolean
}

function Menu(props: Props) {
  const wallet = useWallet()
  const connectedId = isWalletConnected()
  const [btnText, setBtnText] = useState('Connect')
  const [viewCollection, setViewCollection] = useState(false)
  const [textDialogState, setTextDialogState] = useState(false)

  /**
   * @dev Connect wallet to metamask
   */
  const connectMetamask = useCallback(() => {
    // is web3 undefined (not installed) show messages
    if (typeof window.ethereum == 'undefined') {
      setTextDialogState(true)
    } else {
      setViewCollection(!viewCollection)
      if (wallet.status !== 'connected') {
        wallet.connect('injected');
      }
    }
    // ----
  }, [viewCollection, wallet])

  /**
   * @dev Checking if you connected before if yes reconnect.
   */
  const checkConnection = () => {
    if (wallet.status !== 'connected' && connectedId != null) {
      wallet.connect(connectedId)
    }
  }

  const setOrRemoveConnection = useCallback(() => {
    if (wallet && wallet.account) setWalletConnected('injected')
    else localStorage.removeItem('__WALLET_CONNECTED')
  }, [wallet])

  /**
  * @dev Based on the connected chain check if you need to show the wallet address or the wrong network txt
  */
  const getConnectButtonTxt = useCallback(async () => {
    // 0x38 = Binance Mainnet
    // 0x61 = Binance Testnet
    const id =
      config.networkId === 1 ? '0x1' :
        config.networkId === 4 ? '0x4' :
          config.networkId === 2 ? '0x2a' :
            config.networkId === 56 ? '0x38' :
              config.networkId === 97 ? '0x61'
                : '0x1';

    if (window.ethereum) {
      window.ethereum.on('chainChanged', (changedChainID: any) => {
        if (changedChainID === id) return window.location.reload()
        if (changedChainID !== id) return setBtnText('Wrong network')
        else return setBtnText('Connect')
      })
      const chainId = await window.ethereum.request({ method: 'eth_chainId' });
      if (chainId !== id) return setBtnText('Wrong network')
      if (chainId === id && wallet && wallet.account) return setBtnText(truncateFromCenter(wallet.account))
      else return setBtnText('Connect')
    }
  }, [wallet])

  const onNavDropdownItemClick = () => {
    document.body.classList.remove('menu-open');
  }

  useEffect(() => {
    checkConnection()
    //  eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setOrRemoveConnection()
  }, [setOrRemoveConnection])

  useEffect(() => {
    getConnectButtonTxt()
  }, [getConnectButtonTxt])

  return (
    <>
      <div id="navbar">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="nav-toggle nav-trigger">
              <div className="nav-icon">
                <span></span>
              </div>
            </button>
            <a className="logo-main-mob" href="/">
              <span>
                <img src={logo} alt="Cacti Club" />
              </span>
            </a>
            <div className="nav-wrap">
              <nav id="nav-main">
                <ul>
                  <li>
                    <a className="n-link-1" href="https://www.cacticlub.io/#content-1" target='_blank' rel="noreferrer">
                      Story
                    </a>
                  </li>
                  <li>
                    <a className="n-link-2" href="https://www.cacticlub.io/#content-2" target='_blank' rel="noreferrer">
                      Mint Cacti
                    </a>
                  </li>
                  <li>
                    <a className="n-link-3" href="https://www.cacticlub.io/#content-3" target='_blank' rel="noreferrer">
                      The Club
                    </a>
                  </li>
                  <li>
                    <a className="n-link-4" href="https://www.cacticlub.io/#content-4" target='_blank' rel="noreferrer">
                      Mutation
                    </a>
                  </li>
                </ul>
              </nav>
              <a className="logo-main" href="/">
                <span className="logo-main-dark">
                  <img src={logo} alt="Cacti Club" />
                </span>
              </a>
              <nav id="nav-right">
                <ul>
                  <li>
                    <a className="n-link-5" href="https://www.cacticlub.io/#content-5" target='_blank' rel="noreferrer">
                      The team
                    </a>
                  </li>
                  <li>
                    <a className="n-link-6" href="https://www.cacticlub.io/#content-6" target='_blank' rel="noreferrer">
                      Rarity
                    </a>
                  </li>
                  <li>
                    <a className="n-link-7" href="https://www.cacticlub.io/#content-faq" target='_blank' rel="noreferrer">
                      FAQ
                    </a>
                  </li>
					<li><a href="https://staking.cacticlub.io/">Stake</a></li>
                </ul>
                <div className="nav-connect">
                  <button
                    id="wallet-btn"
                    className="button l-btn"
                    onClick={() => wallet.status !== 'connected' ? connectMetamask() : null}>
                    <span>{btnText}</span>
                  </button>
                  {wallet.account && btnText !== 'Wrong network' && props.showCollection &&
                    <div className="nav-dropdown" onClick={() => {
                      props.onClickCollection();
                      if(window.innerWidth <= 768) {
                        onNavDropdownItemClick();
                      }
                    }}>
                      <div className="nav-dropdown-item" id='nav-dropdown-item'>
                        Click to view your collection
                      </div>
                    </div>
                  }
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <TextDialog
        open={textDialogState}
        onClose={() => setTextDialogState(false)}
      />
    </>
  )
}

export default Menu
